import type { TargetKind } from '../game/simulation';

export const RUN_ASSET_PATHS = {
  ranger: '/assets/characters/ranger.png',
  raider: '/assets/characters/raider.png',
  enforcer: '/assets/characters/enforcer.png',
  spitter: '/assets/characters/spitter.png',
  boss: '/assets/characters/boss.png',
} as const;

export type RunAssetKey = keyof typeof RUN_ASSET_PATHS;

export function getTargetAssetKey(kind: TargetKind): RunAssetKey | null {
  if (kind === 'walker' || kind === 'runner') return 'raider';
  if (kind === 'blocker') return 'enforcer';
  if (kind === 'spitter') return 'spitter';
  if (kind === 'boss') return 'boss';
  return null;
}
